<template>
	
        <div class="lime-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-separator-1">
                                <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                                <li class="breadcrumb-item active" aria-current="page">Payment</li>
                            </ol>
                        </nav>
                        <div class="page-title">
                            <!-- <h3>Payment List</h3> -->
                            <!--<div class="search-create">
                            	<form class="form-inline search" id="search">
				                    <input class="form-control mr-sm-2" type="search" placeholder="Search Payment" aria-label="Search" />
				                </form>
                            </div>-->
                            
                        </div>
                        <div class="page-title">
                               <h3>Payments</h3>
                               <div class="search-create">
                    
                                     <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search payments" aria-label="Search" />
                                </div>
                            </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                          <datatable :class="tblCls" :columns="columns" :filter="filter" :per-page="5" :data="paymentList"></datatable>   
                          <datatable-pager v-model="page" class="pagination"></datatable-pager>
                        </div>
                     </div>
                  </div>
            </div>
        </div>
    
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'Payment',
    components: {
      Loading
    },
    data () {
      return {
        tblCls: 'table',
        isLoading: false,
        fullPage: true,
        paymentList: [],
        columns: [
          {label: 'TransactionID', field: 'id'},
          {label: 'Amount', field: 'amount'},
          {label: 'Method', field: 'payment_method'},
          {label: 'Captured', field: 'captured'},
          {label: 'Paid', field: 'paid'},
          {label: 'Status', field: 'status'},
          {label: 'Date', field: 'dateCreated'},
          {label: 'Payment_Type', field: 'pyament_type'}
        ],
        rows: this.paymentList,
        filter: '',
        page: 1
      }
    },
    methods: {
      getUserPayment () {
        var jwttoken = localStorage.getItem('jwt')
        var uid = localStorage.getItem('uid')
        this.isLoading = true
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserPayments' + '?' + 'uid' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.payments = response.data.results
            for (var i in this.payments) {
              var obj = this.payments[i]
              // count++
              this.paymentList.push({
                id: obj.transaction_id,
                amount: obj.amount,
                payment_method: obj.payment_method,
                captured: obj.captured,
                paid: obj.paid,
                status: obj.status,
                dateCreated: obj.dateCreated,
                pyament_type: obj.pyament_type
              })
              console.log(this.paymentList)
            }
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    created () {
      this.getUserPayment()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PaymentUser.vue